<template>
	<div class="page-point">
		<div class="case" v-if="point">
			<time-num></time-num>
			<div class="icons" @click="caseClick()">
				<img src="./../../assets/treat/case.png" alt />
			</div>
		</div>
		<div class="content-cat" v-if="title !== 'dog'">
			<div class="cat">
				<img class="animal" src="./../../assets/treat/animal.png" alt />
				<div class="light">
					<img v-for="(item, index) in catDrop" v-show="!item.accomplish" :class="`light${index}`"
						:src="accomplishImage" @click="lightClick(item, index)" :key="index" alt />
					<img v-for="(item, index) in catDrop" v-show="item.accomplish" :class="`light${index}`"
						:src="lightImage" @click="lightClick(item, index)" :key="item.characteristic" alt />
				</div>
			</div>
		</div>
		<div class="content-dog" v-else>
			<div class="dog">
				<img class="animal" src="./../../assets/treat/dog.png" alt />
				<div class="light">
					<img v-for="(item, index) in catDrop" v-show="!item.accomplish" :class="`light${index}`"
						:src="accomplishImage" @click="lightClick(item, index)" :key="index" alt />
					<img v-for="(item, index) in catDrop" v-show="item.accomplish" :class="`light${index}`"
						:src="lightImage" @click="lightClick(item, index)" :key="item.characteristic" alt />
				</div>
			</div>
		</div>
		<div class="footer-box" v-if="!status">
			<!-- <div class="nextquestionactive" @click="$router.replace('/treat/Catalog')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div> -->
			<div>点击宠物侧立图中的发光点</div>
			<div>查看该部位情况并进行作答</div>
		</div>
		<div class="footer-box" v-else>

			<div>已完成全部视诊</div>
			<div class="returnFlex">
				<!-- <div class="nextquestionactive" @click="$router.replace('/treat/Catalog')">
					<img class="next1" src="./../../assets/home/previous.png"></img>上一步
				</div> -->
				<div class="return" @click="handleBack">
					<!-- <img src="./../../assets/treat/return.png" alt /> -->
					<span>提交</span>
				</div>
			</div>


		</div>
		<Modal v-if="submitFlag"></Modal>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import Modal from "./pointModal.vue";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			Modal,
			TimeNum,
		},
		name: "Point",
		data() {
			return {
				lightImage: require("../../assets/treat/lightRound.png"), //动物身上发光点图片
				accomplishImage: require("../../assets/treat/selectbtn.png"), //动物身上发光点完成图片
				catDrop: [],
				point: null,
			};
		},
		computed: {
			// vuex数据
			...mapState("visualExamination", [
				"selectPosition",
				"submitFlag",
				"selectPositionObj",
				"treatmentList",
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentEcho",
			]),
			...mapState("microscope", ["examDetailId"]),
			// 全部答题状态
			status() {
				const status = this.selectPosition.every((item) => item.accomplish);
				return status;
			},
			title() {
				return this.point.type;
			},
		},
		watch: {
			//猫点
			selectPosition: {
				handler(val) {
					this.catDrop = val;
				},
				deep: true,
			},
		},
		created() {
			this.point = this.treatmentList;
		},
		mounted() {
			this.catDrop = this.selectPosition;
			if (this.selectPositionObj) {
				this.catDrop.map((item) => {
					if (item.id === this.selectPositionObj.id) {
						item.accomplish = this.selectPositionObj.accomplish;
					}
				});
			}
			this.VISUAL_EXAMINATION({
				key: "selectPosition",
				value: this.catDrop
			});
		},
		methods: {
			// vuex赋值方法
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			// 点击猫/狗身上发光点
			lightClick(item, index) {
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: JSON.stringify({
						item: item,
						index: index,
						arr: this.selectPosition
					}),
					questionId: '-1',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.VISUAL_EXAMINATION({
						key: "selectPositionObj",
						value: item
					});
					this.$router.replace({
						path: "/treat/mouth",
						query: {
							list: this.point.step2Questions[index],
						},
					});
				});

			},
			// 跳转视诊病例记录页面
			caseClick() {

				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: JSON.stringify(this.selectPosition),
					questionId: '-2012',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace({
						path: "/treat/medicalrecord",
						query: {
							num: 2
						},
					});
				});
			},
			// 返回诊疗思路页面
			handleBack() {
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: JSON.stringify(this.selectPosition),
					questionId: '-2011',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					const obj = {
						stepTwo: true,
						stepThree: true,
						stepFour: false,
						stepFive: false,
						stepSix: false,
					};
					this.VISUAL_EXAMINATION({
						key: "contentObj",
						value: obj
					});
					this.VISUAL_EXAMINATION({
						key: "overIndex",
						value: 2
					});
					this.$router.replace({
						path: "/treat/medicalrecord",
						query: {
							num: 2.1
						},
					});
				});
			},
		},
	};
</script>

<style lang="less" scoped>
	// * {
	//   margin: 0;
	//   padding: 0;
	//   box-sizing: border-box;
	// }
	.page-point {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		position: relative;

		.case {
			width: 100%;
			padding: 24px 0px 24px 0;
			display: flex;

			.time-num {
				width: 75%;
			}

			.icons {
				width: 93px;
				position: absolute;
				right: 33px;
				top: 28px;
				padding-bottom: 24px;
			}

			img {
				width: 93px;
				height: 93px;
			}
		}

		.content-cat {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			.cat {
				margin-top: 305px;
				position: relative;
				width: 633px;
				height: 529px;
			}

			.animal {
				width: 100%;
				height: 100%;
			}

			.light {
				position: absolute;
				left: 0;
				top: 0;

				img {
					width: 120px;
					height: 120px;
				}

				.light0 {
					position: absolute;
					top: 175px;
					left: 22px;
				}

				.light1 {
					position: absolute;
					top: 126px;
					left: 280px;
				}

				.light2 {
					position: absolute;
					top: 284px;
					left: 295px;
				}

				.light3 {
					position: absolute;
					top: 361px;
					left: 98px;
				}

				.light4 {
					position: absolute;
					top: 20px;
					left: 532px;
				}
			}
		}

		.content-dog {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;

			.dog {
				margin-top: 305px;
				position: relative;
				width: 633px;
				height: 529px;
			}

			.animal {
				width: 100%;
				height: 100%;
			}

			.light {
				position: absolute;
				left: 0;
				top: 0;

				img {
					width: 120px;
					height: 120px;
				}

				.light0 {
					position: absolute;
					top: 39px;
					left: 16px;
				}

				.light1 {
					position: absolute;
					top: 114px;
					left: 295px;
				}

				.light2 {
					position: absolute;
					top: 277px;
					left: 281px;
				}

				.light3 {
					position: absolute;
					top: 351px;
					left: 138px;
				}

				.light4 {
					position: absolute;
					top: 256px;
					left: 521px;
				}
			}
		}

		.footer-box {
			width: 100%;
			height: 357px;
			position: absolute;
			left: 0;
			bottom: 0;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 35px;
			font-family: HarmonyOS Sans SC;
			font-weight: 500;
			color: #333333;
			line-height: 60px;

			// div {
			// 	font-size: 35px;
			// 	font-family: HarmonyOS Sans SC;
			// 	font-weight: 500;
			// 	color: #333333;
			// 	line-height: 60px;
			// }
			.returnFlex {
				margin-top: 81px;
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: center;
			}

			.return {

				width: 201px;
				height: 87px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				display: flex;
				border-radius: 50px;
				align-items: center;
				justify-content: center;

				img {
					width: 36px;
					height: 33px;
				}

				span {
					font-size: 35px;
					font-family: HarmonyOS Sans SC;
					font-weight: 500;
					color: #ffffff;
					line-height: 59px;
					margin-left: 10px;
				}
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
		margin-right: 30px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>